import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './queryParams';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/members/table${`?query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/members/table`;

export const URL = (tableQuery: TableQuery): RouteDefinition => `${baseRoute}/members/table?query=${encodeURIComponent(JSON.stringify(tableQuery))}`;
